import { useData } from 'utils/context'

const useDrawer = () => {
  const { drawer, dispatchDrawer } = useData()
  const setOpen = () => dispatchDrawer({ open: true })
  const setClose = () => dispatchDrawer({ open: false })
  return {
    open: drawer?.open,
    setOpen,
    setClose
  }
}

export default useDrawer
